export const normalizeFontWeight = (fontWeight: string) => {
  if (fontWeight === 'bold') return '700';
  if (fontWeight === 'regular') return '400';
  return fontWeight;
};
